import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { DocumentationModel, DocumentModel } from '../../models/documentation.model';
import { DocumentSaveModel } from '../../models/documentSave.model';

@Injectable()
export class DocumentationService {
  listAllDocuments: Array<DocumentationModel>;
  numHolders = 1;

  constructor(private commonService: CommonService) {}

  getDocumentation(): Observable<{
    listDocuments: DocumentationModel;
    filesNotType: boolean;
  }> {
    const url = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents`;
    return <Observable<any>>this.commonService.getVerb(url).pipe(
      map(({ documents, noType }) => {
        this.listAllDocuments = documents;
        const listDocuments = [];

        documents.forEach((document) => {
          if (document.holder === 'H2') {
            this.numHolders = 2;
          }
        });
        documents.forEach((document) => {
          if (noType) {
            // Evitar que en base al número de fichero se ponga un formato u otro de widget
            document.totalFiles = 0;
          }
          const index = listDocuments.findIndex((e) => e.name === document.category);

          if (index > -1) {
            listDocuments[index][this.getSubcategory(document.holder)].push(document);
          } else {
            // añadir el documento
            listDocuments.push(this.newCategory(document.category));
            listDocuments[listDocuments.length - 1][
              this.getSubcategory(document.holder)
            ].push(document);
          }
        });
        const general = listDocuments.find((a) => a.name === 'MTG_C01');
        const generalPosition = listDocuments.indexOf(general);
        if (generalPosition !== -1) {
          listDocuments.splice(generalPosition, 1);
          listDocuments.unshift(general);
        }
        listDocuments.forEach((category) => {
          category.firstHolder.sort((a: DocumentModel, b: DocumentModel) => {
            if (a.type < b.type) {
              return -1;
            }
            if (a.type > b.type) {
              return 1;
            }
            return 0;
          });
          category.secondHolder.sort((a: DocumentModel, b: DocumentModel) => {
            if (a.type < b.type) {
              return -1;
            }
            if (a.type > b.type) {
              return 1;
            }
            return 0;
          });
          category.common.sort((a: DocumentModel, b: DocumentModel) => {
            if (a.type < b.type) {
              return -1;
            }
            if (a.type > b.type) {
              return 1;
            }
            return 0;
          });
        });

        listDocuments.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });

        const response = {
          listDocuments,
          filesNotType: noType,
        };
        return response;
      }),
    );
  }

  getDocumentationSave(
    category?: string,
    type?: string,
    holder?: string,
  ): Observable<Array<DocumentSaveModel>> {
    const url = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/search`;
    let params: HttpParams = new HttpParams();
    if (category) {
      params = params.append('category', category);
    }
    if (type) {
      params = params.append('type', type);
    }
    if (holder) {
      params = params.append('holder', holder);
    }
    return this.commonService.getVerb<any>(url, false, params);
  }

  newCategory(category) {
    return {
      name: category,
      firstHolder: [],
      secondHolder: [],
      common: [],
    };
  }

  getSubcategory(holder) {
    switch (holder) {
      case 'Titular 1':
        return 'firstHolder';
      case 'Titular 2':
        return 'secondHolder';
      case 'Titular1':
        return 'firstHolder';
      case 'Titular2':
        return 'secondHolder';
      case 'H1':
        return 'firstHolder';
      case 'H2':
        return 'secondHolder';
      default: {
        if (this.numHolders === 1) {
          return 'firstHolder';
        }
        return 'common';
      }
    }
  }

  uploadDocuments(formData: FormData, holder) {
    let params: HttpParams = new HttpParams();
    if (holder) {
      params = params.append('holder', holder);
    }
    const url: string = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/uploadDocs`;
    return this.commonService.postVerb(url, formData, true, params);
  }

  finishUploadDocuments() {
    const url: string = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/checkStatus`;
    return this.commonService.postVerb(url, { checkStatus: true }).pipe(
      map(() => {
        return { status: 5.5 };
      }),
    );
  }

  deleteFile(idFile: string) {
    const url = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/${idFile}`;
    // const url = `https://apides.pibank.es/api/mortgages-docs/1.4.0/documents/${idFile}`;
    return this.commonService.deleteVerb(url);
  }

  downloadFile(idFile: string) {
    const url = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/download/${idFile}`;
    return this.commonService.getVerbFiles(url);
  }
}
